export default __webpack_public_path__ + "static/media/outside.24fac507.jpg";